import { Fragment, useEffect, useState } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { fetchSuggestedPosts } from '@lib/API/blogAPI';
import ItemsTray from '@components/items-tray';
import BlogPostCard from '@components/blog-posts/blog-post-card';

import {
  BlogHomepageCardDetailsType,
  BlogPostType,
  CategoryType,
} from 'src/types';
import { BrowserType } from '@constants/common';
import { PlatformType } from '@invideoio/web-shared/constants/common';
interface YouMayAlsoLikeProps {
  blogCategory: CategoryType;
  blogProfession: BlogHomepageCardDetailsType;
  blogPlatform: BlogHomepageCardDetailsType;
  slug: string;
  platform: PlatformType;
  browser: BrowserType;
}

const YouMayAlsoLike = ({
  blogCategory,
  blogProfession,
  blogPlatform,
  slug,
  platform,
  browser,
}: YouMayAlsoLikeProps) => {
  const [suggestedPosts, setSuggestedPosts] = useState<BlogPostType[]>([]);

  useEffect(() => {
    async function getSuggestedPosts(
      listTypeKey: string,
      listTypeValue: string,
    ) {
      const suggestedPosts = await fetchSuggestedPosts({
        listTypeKey,
        listTypeToSkip: slug,
        listTypeValue,
      });
      setSuggestedPosts(suggestedPosts);
    }

    let listTypeKey = '';
    let listTypeValue = '';
    if (blogProfession) {
      listTypeKey = 'profession';
      listTypeValue = blogProfession.slug;
    } else if (blogPlatform) {
      listTypeKey = 'platform';
      listTypeValue = blogPlatform.slug;
    } else if (blogCategory) {
      listTypeKey = 'categories_v_2';
      listTypeValue = blogCategory.slug;
    }
    if (listTypeKey) {
      getSuggestedPosts(listTypeKey, listTypeValue);
    }
  }, [blogPlatform, blogProfession, blogCategory, slug]);

  if (suggestedPosts && suggestedPosts.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <section className={ivclass('iv-pb-[100px]', 'iv-bg-black-4')}>
        <div className={ivclass('iv-container iv-mx-auto')}>
          <div className={ivclass('iv-grid iv-grid-cols-12 ')}>
            <div className={ivclass('iv-col-span-12', 'iv-overflow-hidden')}>
              <div className={ivclass('iv-grid iv-grid-cols-12')}>
                <div
                  className={ivclass(
                    'iv-col-start-2 iv-col-span-11',
                    'iv-mt-[90px] iv-mb-30',
                    'iv-px-20',
                  )}
                >
                  <div
                    className={ivclass('iv-text-heading-2xl iv-font-extrabold')}
                  >
                    You may also like
                  </div>
                </div>
              </div>
              <div
                className={ivclass(
                  'iv-mt-[35px]',
                  'iv-px-[90px] sm:iv-px-[20px]',
                )}
              >
                <ItemsTray
                  platform={platform}
                  sliderWrapperCls={ivclass(
                    'lg:iv-mr-20',
                    'md:iv-mr-15',
                    'sm:iv-mr-20',
                  )}
                >
                  {suggestedPosts?.map(post => (
                    <div
                      key={post.id}
                      className={ivclass('iv-relative', 'iv-mr-40 md:iv-mr-30')}
                    >
                      <BlogPostCard
                        {...post}
                        browser={browser}
                        devicePlatform={platform}
                        backgroundColorClass={'iv-bg-grey-0'}
                      />
                    </div>
                  ))}
                </ItemsTray>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default YouMayAlsoLike;
